export default __webpack_public_path__ + "static/media/puppies_behind_bars.ab86755b.png";